import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { DigitalCurrencyDepositOrderReq, DigitalCurrencyDepositOrderRes } from '@/types/api/deposit-payment/user-digital-currency-deposit-order.d';

export const getDigitalCurrencyDepositOrder = ({ order_id }: DigitalCurrencyDepositOrderReq) =>
  get<DigitalCurrencyDepositOrderRes>('/wallet/v1/digital_currency/deposit_order', {
    params: { order_id },
  });

const { useQueryHook } = createApiQuery(getDigitalCurrencyDepositOrder, (params) => ['digital-currency-deposit-order', params.order_id]);

export const useGetDigitalCurrencyDepositOrder = useQueryHook;